export const tiktokSx = {
  padding: 0,
};
